import React, { useMemo } from "react"

import styled from "styled-components"

import { RadioGroupContext } from "./context"

export type RadioGroupProps<T = any> = {
  name?: string
  value: T
  onChange: (changeEvent: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  children: React.ReactNode
}

const Fieldset = styled.fieldset`
  margin: 0;
  border: 0;
  padding: 0;
`

export const RadioGroup = ({
  name,
  value,
  children,
  className,
  onChange,
}: RadioGroupProps) => {
  const contextValue = useMemo(() => ({ name, onChange, value }), [value, name, onChange])

  return (
    <RadioGroupContext.Provider value={contextValue}>
      <Fieldset className={className} role="radiogroup">
        {children}
      </Fieldset>
    </RadioGroupContext.Provider>
  )
}

export { Radio } from "./radio"
